import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";

import {
  FabricStyleDetailInquiryCriteriaBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  ObseleteInventoriesPrintRequest,
  ObseleteInventoryInfoBean,
  ObseleteInventorySearchCriteria,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  SKUBatchInventorySearchCriteria,
  SKUInventorySearchCriteria,
  RestCustomerListRequest,
  CustomerSearchCriteria,
} from "../ds/ds.js";
import {
  AlertToolBox,
  CollapseComponent,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
  ColumnDefinition,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupInvoiceModule,
  PopupPurchaseOrderModule,
  PopupPurchaseReceiptModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { ReportService } from "../services/ReportService.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { CustomerService } from "../services/CustomerService.js";
import CustomTable from "../gui_components/CustomTable.js";
class ObseleteInventory extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Obselete Inventory Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      isShowCustomerModule: false,
      isShowInvoiceModule: false,
      isShowFabricStyleModule: false,
      isShowPurchaseModule: false,
      isShowPurchaseReceiptModule: false,
      error_list: [],
      inquiryDataList: [],
      inquiryData: [],
      criteria: new ObseleteInventorySearchCriteria(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: "",
      success_list: [],
      moduleForPopup: [],
      isShowColorLookup: false,
      colorLookupHandler: null,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      inventoryDataBean: new ObseleteInventoryInfoBean(),
      isShowOnHandQtyPopup: false,
      isShowSoldDetailsPopup: false,
      onHandQtyDataList: [],
      soldDetailsList: [],
      onHandQtySummaryDataList: [],
      isDisableFields: false,
      isCollapsible_open: true,
      is3PL: false,
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
    };
    this.fabricCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style",
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription),
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    if (criteria.quantityRange <= 0) {
      criteria.quantityRange = null;
    }
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadObseleteInventoryInquiryList(criteria);
  };
  loadObseleteInventoryInquiryList = (criteria) => {
    if (SecurityAccessManager.ObseleteInventoryInquiry_IsAccessible()) {
      ReportService.inquireObseleteInventories(
        criteria,
        this.loadObseleteInventoryPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadObseleteInventoryPageResponse = (response) => {
    console.log("loadObseleteInventoryPageResponse", response);

    if (response.data != null && response.data.result != null) {
      let obseleteInventoryList = [];
      let inquiryData = response.data.result;
      if (!isEmptyArray(response.data.result.infoBean)) {
        obseleteInventoryList = response.data.result.infoBean;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: obseleteInventoryList,
        inquiryData: inquiryData,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        isLoading: false,
        isCollapsible_open: false,
        loadingText: "",
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateObseleteInventoryReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let cust_criteria = new ObseleteInventorySearchCriteria();
    cust_criteria.companyCode = this.companyCode;
    cust_criteria.fabricStyleCode = criteria.fabricStyleCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new ObseleteInventoriesPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.ObseleteInventoryInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateObseleteInventoriesPrintReport(
          listRequest,
          this.generateObseleteInventoryPageResponse,
          this.errorCallBack,
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.ObseleteInventoryInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateObseleteInventoriesPrintReport(
          listRequest,
          this.generateObseleteInventoryPageResponseForExcel,
          this.errorCallBack,
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateObseleteInventoryPageResponse = (response) => {
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        // window.open(this.report_url + reportFilePath);
        let downloadAddress = toDownloadReportAddress(
          reportFilePath,
          true,
          true,
          this.report_url,
        );
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateObseleteInventoryPageResponseForExcel = (response) => {
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        // window.open(this.report_url + reportFilePath);
        let downloadAddress = toDownloadReportAddress(
          reportFilePath,
          true,
          true,
          this.report_url,
        );
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onHandQuantityClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let inventoryDataBean = this.state.inventoryDataBean;
      inventoryDataBean.companyCode = this.companyCode;
      inventoryDataBean.fabricStyleCode = rowData.fabricStyleCode;
      inventoryDataBean.fabricStyleName = rowData.fabricStyleName;
      inventoryDataBean.fabricStyleColorCode = rowData.fabricStyleColorCode;
      this.setState({ inventoryDataBean: inventoryDataBean });
      let qtyCriteria = new SKUBatchInventorySearchCriteria();
      qtyCriteria.companyCode = this.companyCode;
      qtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      qtyCriteria.colorCode = rowData.fabricStyleColorCode;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestSkuBatchInventoryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = qtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Fetching OnHand Qty...",
      });
      this.loadOnHandQtyListPage(listRequest);
    }
  };
  loadOnHandQtyListPage = (listRequest) => {
    InventoryService.getOpenSkuBatchInventories(
      listRequest,
      this.loadOnHandQtyPageResponse,
      this.errorCallBack,
    );
  };
  loadOnHandQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      if (response.data.skuBatchInventoryPageList.skuBatchInventories != null) {
        const onHandQtyList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
        this.setState({
          onHandQtyDataList: onHandQtyList,
          isShowOnHandQtyPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateOnHandQtyPdf = () => {
    this.generateOnHandQtyReport(1);
  };
  generateOnHandQtyExcel = () => {
    this.generateOnHandQtyReport(2);
  };
  generateOnHandQtyReport = (reportType) => {
    let inventoryDataBean = this.state.inventoryDataBean;
    let criteria = new SKUInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = inventoryDataBean.fabricStyleCode;
    criteria.colorCode = inventoryDataBean.fabricStyleColorCode;
    criteria.totalOnHandQuantity = inventoryDataBean.totalOnHandQuantity;
    criteria.uomCode = inventoryDataBean.uomCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestSkuBatchInventoryListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    ReportService.downloadPopUpItemOnOrderPrintReport(
      listRequest,
      this.generateOnHandQtyResponse,
      this.errorCallBack,
    );
  };
  generateOnHandQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  soldDetailsClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let listRequest = new FabricStyleDetailInquiryCriteriaBean();
      listRequest.companyCode = this.companyCode;
      listRequest.fabricStyleCode = rowData.fabricStyleCode;
      listRequest.colorCode = rowData.fabricStyleColorCode;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Fetching Sold Details...",
      });
      ReportService.getFabricStyleInvoiceDetails(
        listRequest,
        this.getFabricStyleInvoiceResponse,
        this.errorCallBack,
      );
    }
  };
  getFabricStyleInvoiceResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.pageList != null &&
      response.data.pageList.infoBeans != null
    ) {
      const soldDetailsList = response.data.pageList.infoBeans;
      this.setState({
        soldDetailsList: soldDetailsList,
        isShowSoldDetailsPopup: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new ObseleteInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.customerName = "";

    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new Array(),
      colorList: [],
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isCollapsible_open: true,
      isDisableFields: false,
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
    });
    if (this.state.is3PL) {
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        "Item",
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    }
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new ObseleteInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.customerName = "";

    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowColorLookup: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new Array(),
      colorList: [],
      isCollapsible_open: true,
      isDisableFields: false,
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
    });
    if (this.state.is3PL) {
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        "Item",
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    }
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateObseleteInventoryReport(1);
  };
  generateExcel = () => {
    this.generateObseleteInventoryReport(2);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowFabricStyleModule: isOpen,
      isShowPurchaseModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
    });
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseReceiptModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseModule = (e, code, rowData) => {
    console.log("viewPurchaseModule e1", e);
    console.log("viewPurchaseModule code1", code);
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              // isSpecialViewMode={false}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowOnHandQtyPopup: isShowPopup,
      isShowSoldDetailsPopup: isShowPopup,
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        fabricPageListForAutoCompleteList: suggestion,
        colorList: [],
        isShowColorLookup: false,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color",
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack,
    );
  };

  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack,
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    let criteria = this.state.criteria;
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        if (this.state.is3PL) {
          if (!isEmptyString(criteria.logisticCustomerCode)) {
            if (fabricStyle.customerCode == criteria.logisticCustomerCode) {
              let simpleItemBean = {
                code: fabricStyle.fabricStyleCode,
                description: fabricStyle.fabricStyleName,
              };
              simpleAutoCompleteList.push(simpleItemBean);
            }
          } else {
            let simpleItemBean = {
              code: fabricStyle.fabricStyleCode,
              description: fabricStyle.fabricStyleName,
            };
            simpleAutoCompleteList.push(simpleItemBean);
          }
        } else {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        }
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL
        ? "read Item"
        : "Reading FabricStyle",
    });
    this.readandsetFabricStyleDetail(e.target.value);

    this.setState({
      fabricPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };

  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  showHideSecondHeader = () => {
    let isCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: isCollapsible_open });
  };
  onCustomerCodeChange = (e) => {
    let logisticCustomerCode = e.target.value.toUpperCase();
    this.state.isShowAutoCompleteCustomerList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(logisticCustomerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let temp_criteria = this.state.criteria;
      temp_criteria.logisticCustomerCode = "";
      temp_criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: temp_criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "logisticCustomerCode" &&
      showAutoCompleteList === true &&
      logisticCustomerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ criteria: criteria });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let logisticCustomerCode = e.target.value;
    this.readCustomer(logisticCustomerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };

  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;

    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack,
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };

  readCustomerResponse = (response) => {
    const customerData = response.data.customer;
    if (customerData != null) {
      let criteria = this.state.criteria;
      criteria.logisticCustomerCode = customerData.code;
      criteria.customerName = customerData.description;
      this.setState({ criteria: criteria });

      if (this.state.is3PL) {
        let fabricLookupHandler = new FabricStyleLookupHandler(
          this.companyCode,
          "Item",
          criteria.logisticCustomerCode,
        );
        this.setState({ fabricLookupHandler: fabricLookupHandler });
      }
    }
  };

  readCustomer = (logisticCustomerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = logisticCustomerCode;
    readrestInput.isLoadChildren = true;

    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerResponse,
      this.errorCallBack,
    );
  };

  displayAutoCompleteCustomerList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteCustomerList: showAutoCompleteList });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "FabricStyle",
          "fabricStyleCode",
          true,
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item Name" : "FabricStyle Name",
          "fabricStyleName",
          true,
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "8", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("LaseSalesDate", "lastSalesDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("LastReceiptDate", "lastReceiptDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalOnHandQuantity")
        .setClickDetails(true, false, this.onHandQuantityClick, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Shipped Qty", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalShippedQuantity"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sold Amount", "soldAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalSoldAmount")
        .setClickDetails(true, false, this.soldDetailsClick, null),
    );
    return columns;
  };
  onhandQtyColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Receipt#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseReceiptModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Received Date", "receivedDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true,
          true,
        )
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty#", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    return columns;
  };
  fabricSoldDetailsColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewInvoiceModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer PO#", "customerPONumber", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ShippedQty#", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "lineTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let inquiryData = this.state.inquiryData;
    let inventoryDataBean = this.state.inventoryDataBean;
    let onHandQtyDataList = this.state.onHandQtyDataList;
    let soldDetailsList = this.state.soldDetailsList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          {...this.state}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricCodeRef={this.fabricCodeRef}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          showHideSecondHeader={this.showHideSecondHeader}
          onCustomerCodeChange={this.onCustomerCodeChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowOnHandQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"OnHandQty"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>Company Code</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={inventoryDataBean.companyCode}
                    name={"companyCode"}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={inventoryDataBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={onHandQtyDataList}
                  columns={this.onhandQtyColumns()}
                />
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowSoldDetailsPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={
            this.state.is3PL ? "Item Sold Details" : "Fabrics Sold Details"
          }
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>Company Code</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={inventoryDataBean.companyCode}
                    name={"companyCode"}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={inventoryDataBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={soldDetailsList}
                  columns={this.fabricSoldDetailsColumns()}
                />
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  onChange = (e) => {
    this.props.onChange(e);
  };
  fabricCodeOnChange = (e) => this.props.fabricCodeOnChange(e);
  onFabricColourCodeChange = (e) => {
    this.props.onFabricColourCodeChange(e);
  };
  fabricEnterKeyEventHandler = (e) => {
    this.props.fabricEnterKeyEventHandler(e);
  };
  displayAutoCompleteFabricList = () => {
    this.props.displayAutoCompleteFabricList();
  };
  fabricColourEnterKeyEventHandler = (e) => {
    this.props.fabricColourEnterKeyEventHandler(e);
  };
  displayAutoCompleteFabricColorList = () => {
    this.props.displayAutoCompleteFabricColorList();
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) this.props.showHideSecondHeader();
  };
  render() {
    let criteria = this.props.criteria;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          {this.props.is3PL ? (
            <>
              <Col sm="1">
                <FormLabel>Customer</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.props.onCustomerCodeChange}
                  disabled={isDisableFields}
                  name="logisticCustomerCode"
                  placeholder="Customer"
                  value={criteria.logisticCustomerCode}
                  lookupRequired={true}
                  lookupHandler={this.props.customerLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={
                    this.props.customerCodeEnterKeyEventHandler
                  }
                  autoCompleteListData={
                    this.props.customerPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.props.displayAutoCompleteCustomerList
                  }
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteCustomerList
                  }
                  isMandatory={true}
                />
              </Col>
              <Col sm="3">
                <InputTextbox
                  onChange={this.onChange}
                  disabled={true}
                  name="customerName"
                  value={criteria.customerName}
                />
              </Col>
            </>
          ) : null}
          <Col sm="1">
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              onChange={this.fabricCodeOnChange}
              placeholder="Item"
              value={criteria.fabricStyleCode}
              lookupRequired={true}
              lookupHandler={this.props.fabricLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.fabricEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteFabricList}
              showAutoCompleteList={this.props.showAutoCompleteFabricList}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              name="fabricStyleName"
              onChange={this.onChange}
              value={criteria.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col>
            <CollapseComponent
              isOpen={this.props.isCollapsible_open}
              onClick={(e) => this.showHideSecondHeader(e)}
            />
          </Col>
        </Row>
        {this.props.isCollapsible_open && (
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Color</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onFabricColourCodeChange}
                name="colorCode"
                placeholder="color"
                value={criteria.colorCode}
                lookupRequired={this.props.isShowColorLookup}
                lookupHandler={this.props.colorLookupHandler}
                enterKeyEventHandler={
                  this.props.fabricColourEnterKeyEventHandler
                }
                autoCompleteListData={
                  this.props.fabricColourPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteFabricColorList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteFabricColorList
                }
                disabled={!this.props.isShowColorLookup}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Qty Below</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name="quantityRange"
                onChange={this.onChange}
                value={criteria.quantityRange}
                disabled={isDisableFields}
                decimalScale={2}
              />
            </Col>

            <Col sm="1">
              <FormLabel>Assessment Date</FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent_adv
                name="assessmentDate"
                onChange={this.onChange}
                value={criteria.assessmentDate}
                disabled={isDisableFields}
                isMandatory={true}
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

function ObseleteInventoryInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <ObseleteInventory {...props} name="" /> <br />
    </div>
  );
}

export default ObseleteInventoryInquiry;
